import React, { useState, useEffect } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { api, getBranchOwner, get } from "@config"
import { AutoComplete } from 'antd';
const { Option } = AutoComplete

import Select from 'react-select'

import { setCest } from '@taxes/actions'

function Cest(props) {
    const [result, setResult] = useState([])
    const [input, setInput] = React.useState('')

    const branch = getBranchOwner().id

    function search(e) {
        e = e.replace('.', '').replace('.', '').replace('.', '').replace('-', '').replace('-', '')
        setInput(e)
        if (e.length < 4) return

        const searchBy = isNaN(e) ? "description" : "code";
        e = searchBy === "code" ? e.replace(/\D/g, '') : e
        const url = `${api.products.cest}?branch_owner=${branch}&${searchBy}=${e}`;
        const payload = data => {
            setResult(data)
        };

        get(url, payload);
    }
    function onSelect(e) {

        props.setCest(JSON.parse(e))
        setInput(JSON.parse(e).description)
    }

    React.useEffect(() => {
        if(props.cest) {
            setInput(props.cest.description);
        }
    }, [props.cest])

    return <React.Fragment>
        <p className="lead mb-1">
            CEST {props.cest.code}
        </p>
        <AutoComplete
            value={input}
            style={{ width: 300 }}
            onSelect={onSelect}
            onSearch={search}
            disabled={props.loading}
            placeholder="Busque pelo nome ou código"
            options={result}
        >
            {
                result.map(item => <Option key={item.id} value={JSON.stringify(item)}>
                    {item.code} | {item.description.substr(0, 100)}
                </Option>)
            }
        </AutoComplete>
    </React.Fragment>
}

const mapStateToProps = state => ({
    loading: state.loading,
    cest: state.cest
})
const mapDispatchToProps = dispatch => bindActionCreators({
    setCest
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Cest)


// WEBPACK FOOTER //
// ./src/components/pages/fiscal/taxes/cest/index.jsx